import { FlaskConical, ChevronLeft } from 'lucide-react';
import { WeeklyChallenge } from './WeeklyChallenge';
import { DailyChallenge } from './DailyChallenge';
import { LabView } from '../lab/LabView';

export const HomeView = ({
  dailyChallenge,
  shakeWeekly,
  weeklyChallenge,
  weeklyCompleted,
  getTimeRemaining,
  weeklyChallengeCount,
  completeWeeklyChallenge,
  daysUntilNextWeekly,
  recoveryMode,
  shakeDaily,
  showRerollAnimation,
  dailyChallengeCount,
  completeChallenge,
  shareToSocial,
  swapUsed,
  onSwap,
  hardModeActive,
  hardModeChallenge,
  onToggleHardMode,
  // Lab props
  challengeSubView,
  setChallengeSubView,
  userId,
  username,
  isPremium,
  openUpgradeModal,
}) => {
  if (challengeSubView === 'lab') {
    return (
      <div className="animate-fade-in">
        {/* Back nav */}
        <div className="px-3 sm:px-4 mb-3">
          <button
            onClick={() => setChallengeSubView('challenges')}
            className="flex items-center gap-1.5 text-amber-500 hover:text-amber-400 font-black text-sm uppercase tracking-wide transition-all touch-manipulation"
          >
            <ChevronLeft size={16} />
            BACK TO CHALLENGES
          </button>
        </div>
        <LabView
          userId={userId}
          username={username}
          isPremium={isPremium}
          openUpgradeModal={openUpgradeModal}
        />
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-5 px-3 sm:px-4 animate-fade-in">
      <WeeklyChallenge
        key={`weekly-${shakeWeekly}`}
        weeklyChallenge={weeklyChallenge}
        weeklyCompleted={weeklyCompleted}
        shakeWeekly={shakeWeekly}
        getTimeRemaining={getTimeRemaining}
        weeklyChallengeCount={weeklyChallengeCount}
        completeWeeklyChallenge={completeWeeklyChallenge}
        daysUntilNextWeekly={daysUntilNextWeekly}
      />

      <DailyChallenge
        dailyChallenge={dailyChallenge}
        recoveryMode={recoveryMode}
        shakeDaily={shakeDaily}
        showRerollAnimation={showRerollAnimation}
        getTimeRemaining={getTimeRemaining}
        dailyChallengeCount={dailyChallengeCount}
        completeChallenge={completeChallenge}
        shareToSocial={shareToSocial}
        swapUsed={swapUsed}
        onSwap={onSwap}
        isPremium={isPremium}
        hardModeActive={hardModeActive}
        hardModeChallenge={hardModeChallenge}
        onToggleHardMode={onToggleHardMode}
      />

      {/* Motivational banner */}
      <div className="bg-gradient-to-r from-orange-600 to-red-600 border-2 sm:border-3 border-orange-400 p-2 sm:p-3 md:p-4 text-center skew-x-[-2deg]">
        <p className="font-black text-white text-base sm:text-lg md:text-xl uppercase tracking-wider skew-x-[2deg]">
          🔥 STOP OPTIMIZING • START LIVING 🔥
        </p>
      </div>

      {/* Challenge Lab entry card */}
      <button
        onClick={() => setChallengeSubView('lab')}
        className="w-full bg-gradient-to-br from-gray-900 to-black border-2 border-amber-600 hover:border-amber-400 p-4 text-left transition-all group touch-manipulation"
        style={{ boxShadow: '0 4px 6px rgba(0,0,0,0.3)' }}
        onMouseEnter={e => e.currentTarget.style.boxShadow = '0 12px 32px rgba(245,158,11,0.35)'}
        onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.3)'}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-amber-600 p-2 group-hover:bg-amber-500 transition-all">
              <FlaskConical size={20} className="text-black" />
            </div>
            <div>
              <h3 className="text-amber-400 font-black text-lg uppercase tracking-tight leading-none">
                CHALLENGE LAB
              </h3>
              <p className="text-gray-500 text-xs font-bold uppercase mt-0.5">
                SUBMIT IDEAS • VOTE • HALL OF FAME
              </p>
            </div>
          </div>
          <div className="text-amber-600 group-hover:text-amber-400 font-black text-xl transition-all">
            →
          </div>
        </div>
      </button>
    </div>
  );
};
